module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAABOUlEQVQokW3SMUtcQRQF4O8tsoYsNsEU2gQR9oGFv0CUELCRFBKxsNAUsTI+JLCp/AMJRmTATjAQsIkYkAgaEPIjojAhYGNhk0rFSl+KHXXdzW1mYM65Z865NyvLUkcV+Ru8QgW7Qlxvh2QPiEU+hm/owk9cYxSPMC3EvVtopYU0l8Cf8Awf0j3He3xX5MVDxSKfwtfU/QR/0J0wJYZxgyPMC3EjKxfrNVzgrRDXFXlpaatJWZu5txFi1iLQW8Fv/EikRov99sA+CnEbWzjpQg1X6bnaoXRfj9N5jp6sXKw/wV/MCvGLIv/PfO6aPscBBm7DeY1NDGkm/auNNJosnaEhxJVKMv4ZCzjGCJ5iAi/Rh/5EWhbiCp0LMIkdnGJfcwQvMHhnJVXWsXJFXsU7jKdvH2JViJetsH8TAWU7Z165fwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/newimg3.png
// module id = G04y
// module chunks = 2